module.exports = __webpack_public_path__ + "static/media/accident-sign.ff02dd6d.svg";